// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__H7I09","enabled":"styles_enabled__a9Ggv","disabled":"styles_disabled__cE9yy","published":"styles_published__bZGEH","collapsed":"styles_collapsed__ia8RV"};